import Axios from 'axios';

export default class SatelliteApi {
  constructor() {
    this._client = Axios.create({
      baseURL: import.meta.env.VITE_API_URL,
      headers: { 'X-Client-Id': 'ZonApp' },
    });
  }

  getOverviewOfMeters(postalCode, plantCode) {
    return this._client.get('/plant-details', {
      params: {
        postal_code: postalCode,
        plant_code: plantCode,
      },
    });
  }

  getMeterDetails(postalCode, plantCode, meterId) {
    return this._client.get('/meter-plant-details', {
      params: {
        postal_code: postalCode,
        plant_code: plantCode,
        meter_id: meterId,
      },
    });
  }

  getYield(
      companyId: number,
      plantId: number,
      meterId: number,
      startDate: Date,
      endDate: Date,
      yieldType: string,
      periodType: string,
  ) {
    const url = `/company/${companyId}/plant/${plantId}/meter/${meterId}/yield`;

    return this._client.get(url, {
      params: {
        start_date: startDate.toISOString().split('T')[0],
        end_date: endDate.toISOString().split('T')[0],
        yield_type: yieldType,
        period_type: periodType,
      },
    });
  }

  getFaqContent() {
    return this._client.get('/faq', {});
  }
}
